import {
  Component,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'gas-table-radio',
  templateUrl: './gas-table-radio.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasTableRadioComponent {
  @Input()
  public set isChecked(value: boolean) {
    this.isCheckedSubject$.next(value);
  }

  public get isChecked(): boolean {
    return this.isCheckedSubject$.value;
  }

  @Output('selected')
  public selected$ = new EventEmitter<Event>();

  public isChecked$: Observable<boolean>;

  private isCheckedSubject$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.isChecked$ = this.isCheckedSubject$.asObservable();
  }

  public select(event: Event): void {
    this.selected$.emit(event);
  }
}
